<template>
  <el-dialog
    v-model="visible"
    width="900px"
    :show-close="false"
    align-center
    class="bg-transparent! p-0!"
    header-class="hidden"
  >
    <div class="flex">
      <div class="h-[500px] w-[420px] overflow-hidden">
        <el-image
          :src="leftImageSrc"
          fit="cover"
          class="h-full w-full rounded-l-xl"
        />
      </div>
      <div class="relative flex-1 rounded-r-xl bg-white dark:bg-[#121314]">
        <el-image :src="logoSrc" class="absolute top-4 right-4 h-10 w-30" />
        <LoginForm
          @submit="handleSubmit"
          @send-code="handleSendCode"
          :submit-loading="submitting"
          mode="password"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
const { isDark } = useTheme();
const props = defineProps<{
  modelValue: boolean;
  leftImageSrc?: string;
  logoSrc?: string;
}>();
const emit = defineEmits<{ (e: "update:modelValue", v: boolean): void }>();

const visible = computed({
  get: () => props.modelValue,
  set: (v: boolean) => emit("update:modelValue", v),
});

const leftImageSrc = computed(() => props.leftImageSrc ?? "/login.png");
const logoSrc = computed(() => (isDark.value ? "/logo.png" : "/logo1.png"));

const submitting = ref(false);

async function handleSendCode(payload: { country: string; phone: string }) {}

async function handleSubmit(payload: {
  country: string;
  phone: string;
  code?: string;
  password?: string;
}) {
  emit("update:modelValue", false);
}
</script>

<style scoped></style>
